import { render } from "./change-status-menu.vue?vue&type=template&id=3d2a874e"
import script from "./change-status-menu.vue?vue&type=script&setup=true&lang=js"
export * from "./change-status-menu.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/orders/components/change-status-menu.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3d2a874e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3d2a874e', __exports__)) {
    console.log('reload')
    api.reload('3d2a874e', __exports__)
  }
  
  module.hot.accept("./change-status-menu.vue?vue&type=template&id=3d2a874e", () => {
    console.log('re-render')
    api.rerender('3d2a874e', render)
  })

}


export default __exports__